import { ArrowLeftRight, Layers, Ship, TrendingDown, TrendingUp } from 'lucide-react';

export function NotificationIcon({
  ruleType,
  className = 'size-4',
}: {
  ruleType: string;
  className?: string;
}) {
  switch (ruleType) {
    case 'price_drop':
      return <TrendingDown className={`${className} text-red-500`} />;
    case 'price_increase':
      return <TrendingUp className={`${className} text-green-500`} />;
    case 'price_change':
      return <ArrowLeftRight className={`${className} text-yellow-500`} />;
    case 'new_boat_in_comp_set':
      return <Layers className={`${className} text-blue-500`} />;
    default:
      return <Ship className={`${className} text-muted-foreground`} />;
  }
}
